import {Component, Input, OnInit} from '@angular/core';
import { UserVO } from '../../../generate/UserVO';

@Component({
    selector: 'lib-users-list-block',
    templateUrl: './users-list-block.component.html',
    styleUrls: ['./users-list-block.component.css'],
    standalone: false
})
export class UsersListBlockComponent implements OnInit {

  @Input()
  unverifiedUsers: Array<UserVO>;

  constructor() {
  }

  ngOnInit(): void {
  }

}
